module.exports = __webpack_public_path__ + "img/telematik_w.59ee4528.svg";